/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

const visualViewer = {
  contentType: {
    drawing2D: '2D',
    model3D: '3D',
  },
  toolbar: {
    homeButton: { label: 'Casa' },
    zoomButton: { label: 'Zoom' },
    panButton: { label: 'Panela' },
    rotateButton: { label: 'Girar' },
    isolateButton: { label: 'Isolar' },
    playButton: { label: 'Brincar' },
    pauseButton: { label: 'Pausa' },
    hotspotsButton: { label: 'Hotspots', show: 'Show', hide: 'Ocultar' },
    visualViewerAnimationSlider: {
      label: 'Controle deslizante de animação',
      role: 'Controle deslizante',
    },
  },
};

const visualPicking = {
  visualPickingTab: {
    noProductReferences: 'Não há peças de reposição disponíveis para este produto.',
  },
  visualPickingProductList: {
    description: 'Descrição',
    itemPreço: 'Preço',
    outOfStock: 'Sem stock',
    id: 'IDENTIFICAÇÃO',
  },
  visualPickingProductFilter: {
    input: {
      placeholder: 'Filtrar por nome ou ID',
    },
    AcharButton: {
      label: 'Achar',
    },
    reporButton: {
      label: 'repor',
    },
  },
};

const errors = {
  visualLoad: {
    noMatchingVisualFound: 'Nenhuma visualização correspondente encontrada',
    multipleMatchingVisualsFound: 'Várias visualizações correspondentes foram encontradas',
    unexpectedLoadError: 'Ocorreu um erro ao carregar a visualização',
  },
};

export const epdVisualization = {
  epdVisualization: {
    visualViewer,
    visualPicking,
    errors,
  },
};
